import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=1093ab9e&scoped=true"
import script from "./setPassword.vue?vue&type=script&lang=js"
export * from "./setPassword.vue?vue&type=script&lang=js"
import style0 from "./setPassword.vue?vue&type=style&index=0&id=1093ab9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093ab9e",
  null
  
)

export default component.exports